import Routers from "./routes/Routers";
import "./styles/App.scss";

function App() {
  return <Routers />;
}

export default App;
